<template>
    <div>
        <div v-for="(snackB, i) in snacks" :key="i">
            <v-snackbar
                    v-model="snackB.active"
                    :timeout="snackB.timeout"
            >
                <div class="d-flex">
                    <div class="pr-2 font-weight-bold" :class="snackB.titleColor + '--text'">{{snackB.title}}</div>
                    <div>{{snackB.message}}</div>
                </div>
                <template v-slot:action="{}">
                    <v-btn
                            v-for="(btn, i) in snackB.buttons"
                            :key="i"
                            :color="btn.color"
                            text
                            @click="btn.val ? btn.cb(btn.val) : btn.cb(snackB.id)"
                    >
                        {{ btn.title }}
                    </v-btn>
                </template>
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import {events} from "@/core/snack";

export default {
    props: {
        val: Boolean
    },
    data() {
        return {
            snacks: [],
            nextID: 0,
            snackbar: false
        }
    },
    created() {
        events.on('showSnack', (snackConfig) => {this.addSnack(snackConfig)})
    },
    methods: {
        addSnack(config) {

            let snack = {
                active: true,
                id: this.nextID,
                title: null,
                titleColor: null,
                message: config.message || '',
                timeout: config.timeout || 3000,
                position: config.position || 'bottom',
            }
            this.nextID = ++this.nextID

            if (!config.title) {
                snack.title = 'Info'
                snack.titleColor = 'primary'
            }

            if (typeof config.title === 'object') {
                snack.titleColor = config.title.color || 'primary'
                snack.title = config.title.value
            } else {
                snack.title = config.title || 'Info'
                snack.titleColor = 'primary'
            }

            let buttons = []

            if (Array.isArray(config.buttons) && config.buttons.length) {
                buttons = config.buttons.map((btn) => {
                    if (typeof btn === 'string') {
                        return  {title: btn, cb: this.removeSnack, color: 'secondary'}
                    } else {
                        return {
                            title: btn.title || 'Close',
                            cb: btn.cb || this.removeSnack,
                            color: btn.color || 'error',
                            val: btn.val || null
                        }
                    }
                })
            } else {
                buttons = [{title: 'Close', cb: this.removeSnack, color: 'error'}]
            }

            snack.buttons = buttons;

            this.snacks.push(snack)

            setTimeout(() => {
                this.removeSnack(snack.id)
            }, snack.timeout)
        },

        removeSnack(id) {
            this.snacks = this.snacks.filter(obj => obj.id !== id)
        }

    },
    computed: {
    },
}
</script>

<style scoped>

</style>